<template>
  <div
    :class="[bemBlock, { 'visually-hidden' : hidden }, 'pdp-link']"
  >
    <a
      draggable="false"
      :class="[bemElement('link', { clamp: lineClamp > 0 }), 'link']"
      :href="url"
      @click.prevent="$emit('click')"
      @dragstart.prevent="dragDisabled"
    >
      <h2 itemprop="name">
        <template v-if="lineClamp > 0">
          <v-clamp
            autoresize
            :max-lines="lineClamp"
          >{{ productName }}</v-clamp>
        </template>
        <template v-else>
          {{ productName }}
        </template>
      </h2>
    </a>
  </div>
</template>

<script>
import VClamp from 'vue-clamp';
import bemClassesMixin from '../mixins/bemClassesMixin';
import productPropBaseMixin from '../mixins/productPropBaseMixin';
import windowResizeMixin from '../mixins/windowResizeMixin';
import getFrontConfig from '../../common/getFrontConfig';

const {
  responsive: { bp_768: bp768 },
} = getFrontConfig();

export default {
  name: 'BaseProductTileName',

  components: {
    VClamp,
  },

  mixins: [
    bemClassesMixin,
    productPropBaseMixin,
    windowResizeMixin,
  ],

  props: {
    hidden: {
      type: Boolean,
      default: false,
    },
    lineClamp: {
      type: Number,
      default: 2,
    },
    url: {
      type: String,
      required: true,
    },
  },

  data: () => ({
    dataChangeBreakpoint: bp768,
  }),

  computed: {
    productName() {
      return this.isBreakpointMobile ? this.product.sliderProductName || this.name : this.name;
    },
  },

  methods: {
    dragDisabled() {
      // Drag disabled because of a Firefox bad behaviour.
      // Firefox brokes an slider with drag scrolling
    },
  },
};
</script>
